import moment from "moment";
import {
  BookMultiOrder,
  BookPoint
} from "../../features/bookMulti/model/BookMultiOrder";
import { TourType } from "../model/TourType";

const floorToHalf = (num: number): number => {
  return Math.floor(num * 2) / 2;
};

export class TimeWindowValidator {
  minStartTime = (orderDate: string): number => {
    if (moment(orderDate).isBefore(moment().endOf("day"))) {
      // if order is today, start time needs to be at least 60 minutes in the future and rounded down to the nearest half hour
      const currentMinutes =
        moment().get("hour") * 60 + moment().get("minutes");
      const minMinutes = currentMinutes + 60;
      return Math.max(floorToHalf(minMinutes / 60), 5);
    } else {
      return 5;
    }
  };

  validTimeWindowFromTimeWindow = (
    original: [number, number],
    minTime: number
  ): [number, number] => {
    const startTime = Math.max(minTime, original[0]);
    const endTime = Math.max(startTime + 1, original[1]);
    return [startTime, endTime];
  };

  orderWithValidTimeWindows = (order: BookMultiOrder): BookMultiOrder => {
    const minStartTime = order.date ? this.minStartTime(order.date) : 5;
    let singleTimeWindow: [number, number];
    let multiPoints: BookPoint[];
    // reference point of timewindow constraints change depending on tour type
    if (order.type === TourType.Distribution) {
      singleTimeWindow = this.validTimeWindowFromTimeWindow(
        order.singlePoint.timewindow,
        minStartTime
      );
      // we need to reference the last calculated timewindow in order to calculate the next
      let lastCalculatedMultiPoint: BookPoint;
      multiPoints = order.multiPoints.map((p, i) => {
        const returnValue = {
          ...p,
          timewindow: this.validTimeWindowFromTimeWindow(
            p.timewindow,
            i === 0
              ? singleTimeWindow[0]
              : lastCalculatedMultiPoint.timewindow[0]
          )
        };
        lastCalculatedMultiPoint = returnValue;
        return returnValue;
      });
    } else {
      // we need to reference the last calculated timewindow in order to calculate the next
      let lastCalculatedMultiPoint: BookPoint;
      multiPoints = order.multiPoints.map((p, i) => {
        const returnValue = {
          ...p,
          timewindow: this.validTimeWindowFromTimeWindow(
            p.timewindow,
            i === 0 ? minStartTime : lastCalculatedMultiPoint.timewindow[0]
          )
        };
        lastCalculatedMultiPoint = returnValue;
        return returnValue;
      });
      singleTimeWindow = this.validTimeWindowFromTimeWindow(
        order.singlePoint.timewindow,
        multiPoints[multiPoints.length - 1].timewindow[0]
      );
    }
    return {
      ...order,
      singlePoint: {
        ...order.singlePoint,
        timewindow: singleTimeWindow
      },
      multiPoints
    };
  };
}
